import { render } from "./Pago.vue?vue&type=template&id=2e7dc03e&scoped=true"
import script from "./Pago.vue?vue&type=script&lang=js"
export * from "./Pago.vue?vue&type=script&lang=js"

import "./Pago.vue?vue&type=style&index=0&id=2e7dc03e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7dc03e"]])

export default __exports__